import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import { MGMT_OUTCOME_LIST, MGMT_OUTCOME_ADD, MGMT_OUTCOME_DETAIL, MGMT_OUTCOME_UPDATE } from '../../actions';
import {
  MgmtOutcomeListSuccess, MgmtOutcomeListError,
  MgmtOutcomeAddSuccess, MgmtOutcomeAddError,
  MgmtOutcomeDetailSuccess, MgmtOutcomeDetailError,
  MgmtOutcomeUpdateSuccess, MgmtOutcomeUpdateError
} from '../../actions';

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
    }, reject);
  });
}

const onListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'management/outcome/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};
const onAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'management/outcome/add', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data.payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};
const onDetailAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'management/outcome/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};
const onUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'management/outcome/update', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

function* onList(data) {
  try { const response = yield call(onListAsync, data.payload); yield put(MgmtOutcomeListSuccess(response.data)); }
  catch (error) { yield put(MgmtOutcomeListError(error)); }
}
function* onAdd(data) {
  try {
    const response = yield call(onAddAsync, data);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(MgmtOutcomeAddSuccess(response.data));
  } catch (error) { yield put(MgmtOutcomeAddError(error)); }
}
function* onDetail(data) {
  try { const response = yield call(onDetailAsync, data.payload); yield put(MgmtOutcomeDetailSuccess(response.data.data)); }
  catch (error) { yield put(MgmtOutcomeDetailError(error)); }
}
function* onUpdate(data) {
  try {
    const response = yield call(onUpdateAsync, data.payload);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(MgmtOutcomeUpdateSuccess(response.data));
  } catch (error) { yield put(MgmtOutcomeUpdateError(error)); }
}

export function* watchList() { yield takeEvery(MGMT_OUTCOME_LIST, onList); }
export function* watchAdd() { yield takeEvery(MGMT_OUTCOME_ADD, onAdd); }
export function* watchDetail() { yield takeEvery(MGMT_OUTCOME_DETAIL, onDetail); }
export function* watchUpdate() { yield takeEvery(MGMT_OUTCOME_UPDATE, onUpdate); }

export default function* rootSaga() {
  yield all([fork(watchList), fork(watchAdd), fork(watchDetail), fork(watchUpdate)]);
}
